$mol_view_tree2_to_js_test_ex_array_union_foo $mol_object
	bar /$mol_view_tree2_to_js_test_ex_klass_tuple_type
		\a
		<= foo \c
		\b
